function BackupRestore() {
    return (
        <div>
            <h2>Backup Restore</h2>

            <p>
                Your complete information comes here.
            </p>
        </div>
    );
}

export default BackupRestore;